import React, {Component} from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import {Field, change, untouch} from 'redux-form';
import {connect} from 'react-redux';
import {compose} from 'recompose';
import {RESOURCES as inventoryResources} from '../fuseInventoryResourceMap';
import {
    NumberInput,
    minValue
} from 'admin-on-rest';
import {checkTokenStatus} from '../shared/tokenFunctions';
import DefaultPagination from '../admin/Pagination';
import NewTransferCollectionTableRow from '../components/NewTransferCollectionTableRow';
import FuseTheme from '../global/theme';
import RaisedButton from 'material-ui/RaisedButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import ContentCheck from 'material-ui/svg-icons/action/check-circle';
import {Card, CardHeader, CardText} from 'material-ui/Card';
import {
    Table,
    TableHeader,
    TableHeaderColumn,
    TableRow,
    TableRowColumn,
    TableBody
} from "material-ui";

/**
 * A component for generating rows of NewTransferCollectionTableRows for new Transfers.
 * It retrieves Repacks or Retail Boxes, and adds or deletes them from the transfer list.
 *
 */
class NewTransferCollectionTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            displayUpdateMessage: false,
            itemList: [],
            itemUpdated: false,
            itemUpdateMessage: null,
            pageIdx: 1,
            pageTotal: 0,
            showForm: false,
            itemQtyValue: 1,
            transferItems: []
        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleCreateNewItem = this.handleCreateNewItem.bind(this);
        this.handleDeleteItem = this.handleDeleteItem.bind(this);
    }

    componentWillMount() {
        if (this.props.productType) {
            this.fetchData(this.state.pageIdx);
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.productType && (this.props.productType !== prevProps.productType)) {
            this.fetchData(this.state.pageIdx);
            this.props.dispatch(change('record-form', 'item_qty_field', 1));
            this.props.dispatch(untouch('record-form', 'item_qty_field'));
        }
    }

    // Get Repacks or Retail Boxes
    fetchData(page) {
        const params = {
            filter: {},
            pagination: {page: page, perPage: this.props.perPage},
            sort: {field: "collection_id", order: "ASC"},
        };
        let resource;
        // @TODO may change to RepacksRetailBoxes, but requires collection id
        if (this.props.collectionType === 'repack') {
            resource = inventoryResources.Repacks.GET_LIST(params);
        } else if (this.props.collectionType === 'retail_box') {
            resource = inventoryResources.RetailBoxes.GET_LIST(params);
        }

        // Retrieve the data and assign results to the Select choices
        import('../shared/functions')
            .then(functions => {
                const tokenStatus = checkTokenStatus(null);
                if (tokenStatus.expired) {
                    return;
                }
                axios({
                    method: 'get',
                    url: resource.uri,
                    headers: functions.getGetHeaders()
                }).then((result) => {
                    if (result.data.payload_meta && result.data.payload) {
                        let total = result.data.payload_meta.total;
                        let choices = this.processChoices(result.data.payload);
                        this.setState({
                            itemList: choices,
                            pageIdx: page,
                            pageTotal: total
                        });
                    }
                }).catch((error) => {
                    let message = '';
                    if (error.response) {
                        // Server response outside 2xx
                        console.log(error.response.data);
                        if (error.response.data.error_message) {
                            message = error.response.data.error_message;
                            console.log('Error: ' + message);
                        }
                    } else if (error.request) {
                        // No response
                        console.log(error.request);
                    } else {
                        console.log('Error', error.message);
                    }
                });
            });
    }

    /**
     * Add parameters to Collection choices
     *
     * @param choices
     * @return array
     */
    processChoices(choices) {
        const type = this.props.collectionType;
        for (let choice of choices) {
            // Set a Barcode based on Collection ID
            choice.barcode = choice.collection_id;
            // Set a Transfer Type
            choice.transfer_type = type;
            delete choice.collection_id;
        }
        return choices;
    }

    // Retrieve data per page change from Pagination
    setPage = (page) => {
        if (this.state.pageIdx !== page) {
            this.fetchData(page);
        }
    };

    handleInputChange(event, index) {
        this.setState({
            displayUpdateMessage: false,
            itemUpdated: false,
            itemUpdateMessage: null
        });
    }

    // Handle event to display form and table
    handleFormDisplay = () => {
        this.setState({
            showForm: true
        });
    };

    // Create a new item based on field values
    handleCreateNewItem = (e) => {

        const barcode = e.barcode;
        const qty = this.props.itemQtyValue;
        const contents = e.contents;
        if (!barcode || !qty) {
            return;
        }

        let transferItems = this.props.transferItems;
        let displayUpdateMessage = false;
        let itemUpdated = false;
        let itemUpdateMessage = null;
        const transferType = this.props.collectionType;
        const collectionSingle = (this.props.collectionType === 'repack') ? 'Repack' : 'Retail Box';

        // Determine if item already exists in list
        let existingItem = transferItems.find(item => item.barcode.toString() === barcode.toString());
        if (existingItem) {
            if (existingItem.qty === qty) {
                // No update to existing item
                displayUpdateMessage = true;
                itemUpdateMessage = 'This ' + collectionSingle + ' with this Quantity is already in the Transfer list. No update was made.';
            } else {
                // Update the existing item's quantity
                existingItem.qty = qty;
                itemUpdated = true;
                displayUpdateMessage = true;
                itemUpdateMessage = 'This ' + collectionSingle + ' is already in the Transfer list. Its Quantity has been updated with the new amount.';
            }
        } else {
            // Add the new item
            transferItems.push({barcode: barcode, qty: qty, transfer_type: transferType, contents: contents});
            itemUpdated = true;
            displayUpdateMessage = true;
            itemUpdateMessage = 'Added item to the Transfer list.';
        }

        // Dispatch events
        if (itemUpdated) {
            this.props.onAddUpdate({transferItems: transferItems});
            this.props.dispatch(change('record-form', 'transfer_items', transferItems));
        }

        // Reset fields and update state
        if (transferType === 'retail_box') {
            this.props.dispatch(change('record-form', 'item_qty_field', 1));
            this.props.dispatch(untouch('record-form', 'item_qty_field'));
        }
        this.setState({
            displayUpdateMessage: displayUpdateMessage,
            itemUpdateMessage: itemUpdateMessage,
            itemQtyValue: null,
            transferItems: transferItems
        });

    };

    // Handle event from item Delete icon
    handleDeleteItem = (item) => {
        const collectionSingle = (this.props.collectionType === 'repack') ? 'Repack' : 'Retail Box';
        let transferItems = this.props.transferItems;
        let idx = transferItems.findIndex(listItem => listItem.barcode === item.barcode);
        if (idx !== -1) {
            // Remove the item if it exists
            transferItems.splice(idx, 1);

            this.props.onDeleteUpdate({transferItems: transferItems});
            this.props.dispatch(change('record-form', 'transfer_items', transferItems));

            this.setState({
                displayUpdateMessage: true,
                itemUpdateMessage: 'Removed ' + collectionSingle + ' ' + item.barcode.toString() + ' from Transfer list.',
                transferItems: transferItems
            });
        }
    };

    // Create table of Collection results or selected items
    makeCollectionTable = (tableType, list, addFunc, deleteFunc) => {
        const resultStyles = {
            iconRow: {width: 50, maxWidth: 50, height: 36, paddingLeft: 14, paddingRight: 16},
            row: {height: 36},
        };
        const itemStyles = {
            iconRow: {width: 50, maxWidth: 50, height: 40, paddingLeft: 14, paddingRight: 16},
            row: {height: 40},
        };
        const styles = (tableType === 'items') ? itemStyles : resultStyles;

        if (!list || list.length === 0 || !list.length) {
            return (
                <TableRow style={styles.row}>
                    <TableRowColumn style={styles.row}>No Items</TableRowColumn>
                    <TableRowColumn style={styles.row}>&nbsp;</TableRowColumn>
                    <TableRowColumn style={styles.row}>&nbsp;</TableRowColumn>
                    <TableRowColumn style={styles.iconRow}>&nbsp;</TableRowColumn>
                </TableRow>
            )
        }
        let collectionList = [];
        const type = this.props.collectionType;
        if (tableType === 'items') {
            // For selected items, display Collection items only of this Transfer Type
            for (let item of list) {
                if (item.transfer_type && item.transfer_type === type) {
                    collectionList.push(item);
                }
            }
        } else {
            // For results, display all items
            collectionList = list;
        }
        return (
            collectionList.map((item, index) => (
                <NewTransferCollectionTableRow
                    key={item.barcode.toString() + index}
                    data={item}
                    tableType={tableType}
                    onAddClick={addFunc}
                    onDeleteClick={deleteFunc}
                />
            ))
        )
    };

    render() {
        const {
            perPage,
            productType
        } = this.props;
        const {
            pageIdx,
            pageTotal
        } = this.state;

        const styles = {
            addBlock: {padding: '8px 0 0 16px'},
            alignBottom: {verticalAlign: 'bottom'},
            alignTop: {verticalAlign: 'top'},
            block: {display: 'block'},
            button: {display: 'inline-block', margin: '0 0 0 1em'},
            error: {
                display: 'block',
                width: 'auto',
                fontSize: '12px',
                color: FuseTheme.palette.accent1Color,
            },
            fieldHeader: {
                display: 'block',
                width: '100%',
                fontSize: '16px',
                fontWeight: 'bold',
                color: FuseTheme.palette.textColor,
                margin: '1em 0 0 0',
            },
            fieldDescription: {
                display: 'block',
                width: '100%',
                fontSize: '14px',
                color: FuseTheme.palette.lightTextColor,
                margin: '0 0 1em 0',
            },
            fieldInline: {display: 'inline-block', width: 'auto', marginRight: '1em'},
            fieldSmall: {display: 'inline-block', maxWidth: 100},
            icon: {display: 'inline-block', fontSize: 16, marginRight: 4, verticalAlign: 'sub'},
            iconCheck: {color: FuseTheme.palette.accent3Color},
            itemsRow: {height: 40},
            itemsIconRow: {width: 50, maxWidth: 50, height: 40, paddingLeft: 14, paddingRight: 16},
            marginTop: {margin: '1em 0 0 0'},
            resultsRow: {height: 36},
            resultsIconRow: {width: 50, maxWidth: 50, height: 36, paddingLeft: 14, paddingRight: 16},
            tableCard: {display: 'block', margin: '1em 0 0 0'},
        };

        const collectionSingle = (this.props.collectionType === 'repack') ? 'Repack' : 'Retail Box';
        const collectionPlural = (this.props.collectionType === 'repack') ? 'Repacks' : 'Retail Boxes';

        return (
            <div>
                {!productType &&
                <span style={{...styles.fieldDescription, ...styles.fieldInline}}>
                    You must select Locations before adding Transfer content.
                </span>
                }
                {!this.state.showForm && productType &&
                <div style={styles.marginTop}>
                    <RaisedButton
                        primary
                        label={`Add ${collectionPlural}`}
                        icon={<ContentAdd/>}
                        onClick={(e) => this.handleFormDisplay(e)}
                    />
                </div>
                }
                {this.state.showForm && productType &&
                <div style={styles.marginTop}>
                    <Card style={styles.tableCard}>
                        <CardHeader title={collectionPlural}/>
                        <CardText>
                            {/* Instructions */}
                            <span style={styles.fieldDescription}>
                                Below are {collectionPlural}. Browse the results for a {collectionSingle}.
                                {this.props.collectionType === 'repack' &&
                                <span>
                                    Browse the results for a Repack. Click its Add icon to add it to the Transfer list.
                                    <br/><br/>
                                    Repacks may only have a quantity of 1.
                                </span>
                                }
                                {this.props.collectionType === 'retail_box' &&
                                <span>
                                    Browse the results for a Retail Box and set its Quantity. Click its Add icon to
                                    add it to the Transfer list.
                                </span>
                                }
                                <br/><br/>
                                To remove a {collectionSingle} from the list, click its Delete icon.
                            </span>
                            <div>
                                {this.props.collectionType === 'retail_box' &&
                                <div>
                                    {/* Quantity Field (Retail Box only) */}
                                    <span style={{...styles.fieldDescription, ...styles.fieldInline}}>
                                        Enter the Quantity of {collectionPlural} you intend to add:
                                    </span>
                                    <Field name="item_qty_field"
                                           label="Quantity"
                                           component={NumberInput}
                                           step={1}
                                           value={1}
                                           onChange={this.handleInputChange}
                                           validate={[minValue(1, 'Must be at least 1.')]}
                                           elStyle={styles.fieldSmall}
                                           defaultValue={this.state.itemQtyValue}
                                    />
                                </div>
                                }
                                <div className="transfer-results-table">
                                    {/* Table: Collection Results */}
                                    <Table selectable={false} multiSelectable={false}>
                                        <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                                            <TableRow style={styles.resultsRow}>
                                                <TableHeaderColumn style={styles.resultsRow}>ID</TableHeaderColumn>
                                                <TableHeaderColumn style={styles.resultsRow}>Created</TableHeaderColumn>
                                                <TableHeaderColumn
                                                    style={styles.resultsRow}>Contents</TableHeaderColumn>
                                                <TableHeaderColumn
                                                    style={styles.resultsIconRow}>Add</TableHeaderColumn>
                                            </TableRow>
                                        </TableHeader>
                                        <TableBody displayRowCheckbox={false}>
                                            {[...this.makeCollectionTable('results', this.state.itemList, this.handleCreateNewItem, null)]}
                                        </TableBody>
                                    </Table>
                                </div>
                                <div>
                                    {pageTotal > 0 &&
                                    <DefaultPagination
                                        page={parseInt(pageIdx, 10)}
                                        perPage={perPage}
                                        total={pageTotal}
                                        setPage={this.setPage}
                                    />
                                    }
                                </div>
                                {this.state.displayUpdateMessage &&
                                <span style={styles.fieldDescription}>
                                    {/* Messaging */}
                                    <ContentCheck style={{...styles.icon, ...styles.iconCheck}}/>
                                    {this.state.itemUpdateMessage}
                                </span>
                                }
                            </div>

                            {/* Table: Selected Transfer Items */}
                            <span style={styles.fieldHeader}>
                                {collectionPlural} in Transfer List
                            </span>
                            <Table selectable={false} multiSelectable={false}>
                                <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                                    <TableRow style={styles.itemsRow}>
                                        <TableHeaderColumn style={styles.itemsRow}>ID</TableHeaderColumn>
                                        <TableHeaderColumn style={styles.itemsRow}>Quantity</TableHeaderColumn>
                                        <TableHeaderColumn style={styles.itemsRow}>Contents</TableHeaderColumn>
                                        <TableHeaderColumn
                                            style={styles.itemsIconRow}>Remove</TableHeaderColumn>
                                    </TableRow>
                                </TableHeader>
                                <TableBody displayRowCheckbox={false}>
                                    {[...this.makeCollectionTable('items', this.props.transferItems, null, this.handleDeleteItem)]}
                                </TableBody>
                            </Table>
                        </CardText>
                    </Card>
                </div>
                }
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    let form = state.form['record-form'];
    if (form && form.values) {
        const qtyValue = (form.values['item_qty_field']) ? parseInt(form.values['item_qty_field'], 10) : 1;
        const dba = (form.values['location_from_dba']) ? (form.values['location_from_dba']) : null;
        const productTypeValue = (dba && dba.product_type) ? dba.product_type.toString() : null;
        const transferItems = (form.values['transfer_items']) ? form.values['transfer_items'] : [];
        return {
            itemQtyValue: qtyValue,
            productType: productTypeValue,
            transferItems: transferItems
        }
    }
    return {
        itemQtyValue: 1,
        productType: null,
        transferItems: []
    }
};

NewTransferCollectionTable.propTypes = {
    addField: PropTypes.bool,
    collectionType: PropTypes.string.isRequired,
    itemQtyValue: PropTypes.number,
    onAddUpdate: PropTypes.func,
    onDeleteUpdate: PropTypes.func,
    perPage: PropTypes.number,
    productType: PropTypes.string,
    showCreate: PropTypes.bool,
    transferItems: PropTypes.array,
};

NewTransferCollectionTable.defaultProps = {
    addField: true,
    collectionType: "repack",
    transferItems: [],
    itemQtyValue: 1,
    perPage: 100,
    showCreate: false,
};

const enhance = compose(
    connect(mapStateToProps)
);

export default enhance(NewTransferCollectionTable);



// WEBPACK FOOTER //
// ./src/Fuse/components/NewTransferCollectionTable.js